var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('selectable-customer-groups',{attrs:{"value":_vm.customerGroup,"show-chips":"","multiple":"","grid-options":_vm.gridOptions},on:{"select":_vm.onSelect}})}
var staticRenderFns = []

export { render, staticRenderFns }